module.exports = __webpack_public_path__ + "images/arrow_down_85056eb8104c38f23362d66243071062.svg";